import React from 'react'
import './whoservemain.scss'
import { MainHeading, PageHeaderIntro, AltCard, FindAgent } from '../../../components';
import { images } from "../../../utils/customFn";
import { Container, Row, Col } from 'react-bootstrap';
const WhoServeMain = () => {

  const HeaderData = [
    {
      image: images['Teamwork_Safety_Moving_Blue.svg'],
      para: 'We don’t just sell business insurance—we offer you our industry knowledge and experience. We specialize in serving industries where we’ve had success building partnerships, many spanning decades. This specialization makes good business sense. Why? Because we can put our industry insights to work for you.',
      para1: 'Click on your industry to learn more about the tailored products and services we offer.',
      para2: 'Are you a national accounts broker or part of a large business looking for loss-sensitive program options? We offer specialized services for national accounts and brokers.',
    },
  ];

  const altCardData = {
    heading: "Dealerships",
    image: images['S1-T4-Who-we-serve_dealerships.avif'],
    content: {
      mainLink: {
        url: "/whoweserve/dealershipsinsurance",
        text: "Learn more about dealership insurance >",
      },
      description:
        "Since 1969, our customizable coverage has been helping protect dealers who sell everything from cars to boats, to farm equipment, and more.",
      links: [
        {
          url: "/whoweserve/dealershipsinsurance/agriculture-equipment-dealerships",
          text: "Agriculture equipment dealerships >",
        },
        {
          url: "/whoweserve/dealershipsinsurance/boat-dealers",
          text: "Boat dealerships >",
        },
        {
          url: "/whoweserve/dealershipsinsurance/industrial-equipment-dealers",
          text: "Industrial equipment dealerships >",
        },
        {
          url: "/whoweserve/dealershipsinsurance/auto-dealerships",
          text: "Auto dealerships >",
        },
        {
          url: "/whoweserve/dealershipsinsurance/harley-davidson-dealerships",
          text: "Harley-Davidson® dealerships >",
        },
        {
          url: "/whoweserve/dealershipsinsurance/rv-dealerships",
          text: "RV dealerships >",
        },
      ],
    },
  };

  const altCardData1 = {
    heading: "Manufacturing and process",
    image: images['who-we-serve_ManufacturingProcess.avif'],
    content: {
      mainLink: {
        url: "/whoweserve/manufactureinsurance",
        text: "Learn more about insurance for manufacturing and process businesses >",
      },
      description:
        "Since 1969, our customizable coverage has been helping protect dealers who sell everything from cars to boats, to farm equipment, and more.",
      links: [
        {
          url: "/whoweserve/manufactureinsurance/electronic-manufacturers",
          text: "Electronic component >",
        },
        {
          url: "/whoweserve/manufactureinsurance/food-processing-insurance",
          text: "Food processing >",
        },
        {
          url: "/whoweserve/manufactureinsurance/plastic-and-rubber-goods-manufacturers",
          text: "Plastics and rubber goods >",
        },
        {
          url: "/whoweserve/manufactureinsurance/farm-equipment-manufacturing",
          text: "Farm equipment manufacturing >",
        },
        {
          url: "/whoweserve/manufactureinsurance/metalworking-insurance",
          text: "Metalworking >",
        },
        {
          url: "/whoweserve/manufactureinsurance/printers-insurance",
          text: "Printing >",
        },
      ],
    },
  };

  const service = {
    heading: "Service",
    image: images['who-we-serve_services.avif'],
    content: {
      mainLink: {
        url: "/whoweserve/serviceindustries",
        text: "Learn more about insurance for service industries >",
      },
      description:
        "Whether you’re in financial services, the auto services industry, healthcare, or another service industry, we have the experience to help protect your company.",
      links: [
        {
          url: "/whoweserve/serviceindustries/automotive-repair-shop-insurance",
          text: "Automotive repair >",
        },
        {
          url: "/whoweserve/serviceindustries/communications-businesses-insurance",
          text: "Communications >",
        },
        {
          url: "/whoweserve/serviceindustries/financial-services-business-insurance",
          text: "Financial services >",
        },
        {
          url: "/whoweserve/serviceindustries/hospitality-businesses",
          text: "Hospitality >",
        },
        {
          url: "/whoweserve/serviceindustries/golf-course-insurance",
          text: "Golf insurance >",
        },
        {
          url: "/whoweserve/serviceindustries/educational-insurance",
          text: "Education >",
        },
        {
          url: "/whoweserve/serviceindustries/healthcare-businesses",
          text: "Healthcare >",
        },
        {
          url: "/whoweserve/serviceindustries/commercial-real-estate",
          text: "Real estate >",
        },
      ],
    },
  };

  const altCardData2 = {
    heading: "Construction",
    image: images['Who-we-serve_construction.avif'],
    content: {
      mainLink: {
        url: "/whoweserve/constructioninsurance",
        text: "Learn more about construction insurance >",
      },
      description:
        "Whether you’re an independent contractor or a large business owner, we’ve got a variety of construction coverages for your company.",
      links: [],
    },
  };

  const altCardData3 = {
    heading: "Retailers and distributors",
    image: images['who-we-serve_retail.avif'],
    content: {
      mainLink: {
        url: "/whoweserve/distributorsandretailers",
        text: "Learn more about distributors and retailers insurance >",
      },
      description:
        "Whether you’re an independent contractor or a large business owner, we’ve got a variety of construction coverages for your company.",
      links: [
        {
          url: "/whoweserve/distributorsandretailers/distributors-and-wholesaler-insurance",
          text: "Distributors >",
        },
        {
          url: "/whoweserve/distributorsandretailers/retailer-insurance",
          text: "Retailers >",
        },
      ],
    },
  };

  const trucking = {
    heading: "Trucking",
    image: images['who-we-serve_transportation.avif'],
    content: {
      mainLink: {
        url: "/whoweserve/truckinginsurance",
        text: "Learn more about trucking insurance >",
      },
      description:
        "We’re dedicated to getting to know your trucking business so we can provide you with the customized coverage you deserve. Our experience is your success.",
      links: [],
    },
  };

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  return (
    <div className='who-we-serve-wrapper'>
      <Container>
        {/* heading  */}
        <MainHeading title="Who we serve" showshare={false} />
        {/* page intro */}
        <PageHeaderIntro Data={HeaderData} />
      </Container>
      <div className='alt-card-wrapper'>
        <Container>
          <div className='title-heading'>
            <h2>Our industries</h2>
          </div>
          <div className='card-list'>
            <Row>
              <Col sm={12} md={6} lg={5} xl={5}>
                <AltCard
                  heading={altCardData2.heading}
                  image={altCardData2.image}
                  content={altCardData2.content}
                />
              </Col>
              <Col sm={12} md={6} lg={7} xl={7}>
                <AltCard
                  heading={altCardData.heading}
                  image={altCardData.image}
                  content={altCardData.content}
                />
              </Col>
            </Row>
          </div>
          <div className='card-list'>
            <Row>
              <Col sm={12} md={6} lg={7} xl={7}>
                <AltCard
                  heading={altCardData1.heading}
                  image={altCardData1.image}
                  content={altCardData1.content}
                />
              </Col>
              <Col sm={12} md={6} lg={5} xl={5}>
                <AltCard
                  heading={altCardData3.heading}
                  image={altCardData3.image}
                  content={altCardData3.content}
                />
              </Col>
            </Row>
          </div>
          <div className='card-list'>
            <Row>
              <Col sm={12} md={6} lg={5} xl={5}>
                <AltCard
                  heading={trucking.heading}
                  image={trucking.image}
                  content={trucking.content}
                />
              </Col>
              <Col sm={12} md={6} lg={7} xl={7}>
                <AltCard
                  heading={service.heading}
                  image={service.image}
                  content={service.content}
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container>
        <FindAgent options={Selectoptions} />
      </Container>
    </div>
  )
}

export default WhoServeMain